import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button, makeStyles, Typography } from '@material-ui/core';
import MyGoogleMap from '../../widgets/MyGoogleMap';
import pageUtilsPropTypes from '../../page/page-prop-types';

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: theme.spacing(3),
  },
}));

const MyInputCoordinate = (props) => {
  const {
    name,
    value,
    onChange,
    defaultValue,
    inputRef,

    pageUtils,
    markerLabel,
    defaultIsShowMap,
    showMapLabelId,
    helperTextLabelId,

    disabled,
  } = props;

  const classes = useStyles();

  const defaultLat = defaultValue ? parseFloat(defaultValue.split(':')[0]) : -6.9034443;
  const defaultLng = defaultValue ? parseFloat(defaultValue.split(':')[1]) : 107.5731162;
  const defaultLatLng = `${defaultLat}:${defaultLng}`;
  const [centerLat, setCenterLat] = React.useState(value ? parseFloat(value.split(':')[0]) : defaultLat);
  const [centerLng, setCenterLng] = React.useState(value ? parseFloat(value.split(':')[1]) : defaultLng);
  const [lat, setLat] = React.useState(value ? parseFloat(value.split(':')[0]) : defaultLat);
  const [lng, setLng] = React.useState(value ? parseFloat(value.split(':')[1]) : defaultLng);

  const [internalValue, setInternalValue] = React.useState(onChange ? defaultLatLng : defaultValue);

  const [isShowMap, setIsShowMap] = React.useState(defaultIsShowMap);

  const handleChangeMarker = (e) => {
    const newLat = e.latLng.lat();
    const newLng = e.latLng.lng();
    setLat(newLat);
    setLng(newLng);
    setCenterLat(newLat);
    setCenterLng(newLng);
    const newLatLng = `${newLat}:${newLng}`;
    setInternalValue(newLatLng);
    if (onChange) {
      onChange({
        skipPersist: true,
        target: {
          name,
          value: newLatLng,
        },
      });
    }
  };

  const handleLoadMap = () => {
    // startGeocode(formValues["address"].trim());
    // setDisabledSubmitButton(false)
    const originLat = value ? parseFloat(value.split(':')[0]) : defaultLat;
    const originLng = value ? parseFloat(value.split(':')[1]) : defaultLng;
    const latLng = `${originLat}:${originLng}`;
    setInternalValue(latLng);
    if (onChange) {
      onChange({
        skipPersist: true,
        target: {
          name,
          value: latLng,
        },
      });
    }
  };

  const handleErrorGoogleMap = () => {
    pageUtils.showSnackbar(
      <FormattedMessage id="register.form.location.error.loadMap" />,
      'error',
    );
  };

  return (
    <div
      className={classes.container}
    >
      <input
        type="hidden"
        value={internalValue}
        name={name}
        ref={inputRef}
      />
      {
        isShowMap ? (
          <>
            <MyGoogleMap
              onLoadMap={handleLoadMap}
              onErrorLoad={handleErrorGoogleMap}
              centerLat={centerLat}
              centerLng={centerLng}
              lat={lat}
              lng={lng}
              onChangeMarker={handleChangeMarker}
              disabled={disabled}
              markerLabel={markerLabel}
            />
            <Typography variant="subtitle1" color="textSecondary">
              <FormattedMessage id={helperTextLabelId || 'myInputCoordinate.helperText'} />
            </Typography>
          </>
        ) : (
          <Button
            variant="contained"
            color="primary"
            onClick={() => setIsShowMap(true)}
          >
            <FormattedMessage id={showMapLabelId || 'myInputCoordinate.button.showMap'} />
          </Button>
        )
      }
    </div>
  );
};

MyInputCoordinate.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func,
  defaultValue: PropTypes.string,
  inputRef: PropTypes.any,

  pageUtils: pageUtilsPropTypes.isRequired,
  markerLabel: PropTypes.string,
  showMapLabelId: PropTypes.string,
  helperTextLabelId: PropTypes.string,
  defaultIsShowMap: PropTypes.bool,

  disabled: PropTypes.bool,
};

MyInputCoordinate.defaultProps = {
  value: undefined,
  onChange: undefined,
  defaultValue: undefined,
  inputRef: undefined,

  defaultIsShowMap: false,
  showMapLabelId: undefined,
  helperTextLabelId: undefined,
  markerLabel: undefined,

  disabled: false,
};

export default MyInputCoordinate;
